module.exports = __webpack_public_path__ + "static/img/s41.1c40cead.png";